import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Button } from 'antd';

function FooterTop(props) {
  const {  isMobile } = props;
  return (
    <div className='footer-top'>
      {/* <OverPack >
        <QueueAnim
          delay={0}
          animConfig={[{ opacity :[0.5,1]}]}
          key="queue"
          type="top"
          leaveReverse
          interval={10}
          component={'div'}
        > */}
          <div className='footer-top-wrapper'>
            <span>立即注册，体验全新信创高性能数据库服务</span>
            <a target='_blank' href='https://www.xiaodun.com/register' className='footer-top-btn'>立即申请</a>
          </div>
        {/* </QueueAnim>
        </OverPack> */}

    </div>
  );
}

export default FooterTop;
